// Set your APP_ID
import { intercomConfigContext } from './intercomConfig'

export const APP_ID = 'a3zrft9d'

// Loads Intercom with the snippet
// This must be run before boot, it initializes window.Intercom

declare global {
    interface Window {
        Intercom: any
    }
}

// prettier-ignore
const loadIntercom = () => {
  (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');// @ts-ignore
    ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + APP_ID;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
}

// Initializes Intercom
const bootIntercom = (options = {}) => {
    window &&
        window.Intercom &&
        window.Intercom('boot', {
            app_id: intercomConfigContext.getConfig().INTERCOM_APP_ID,
            alignment: 'right',
            ...options,
        })
}

const updateIntercom = () => {
    window && window.Intercom && window.Intercom('update')
}

export { loadIntercom, bootIntercom, updateIntercom }
